import { render, staticRenderFns } from "./LgFinderPagePessoa.vue?vue&type=template&id=7423ba92"
import script from "./LgFinderPagePessoa.vue?vue&type=script&lang=js"
export * from "./LgFinderPagePessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports